import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Tabs, Table, message, Button, Space, Modal, Spin } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";
import BackRouteButton from "src/common/components/BackRouteButton";

export default ({
  removeStorehouseInstance,
  storehouse,
  profile,
  recountStorehouse,
}) => {
  let history = useHistory();
  const [loading, setLoading] = useState(false);
  const [productInstances, setProductInstances] = useState(false);
  const [rawMaterialInstances, setRawMaterialInstances] = useState(false);

  const handleEditInstance = async (instance) => {
    history.push({
      pathname: `/storehouse/settings/instance/edit`,
      state: { instance },
    });
  };
  const handleWriteOffInstance = async (instance) => {
    history.push({
      pathname: `/storehouse/settings/instance/write_off`,
      state: { instance },
    });
  };

  const handleRecount = async () => {
    setLoading(true);
    var result = await recountStorehouse();

    if (result.success) {
      message.success("Storehouse successfully recounted!");
      setLoading(false);
    } else {
      message.error(result.message || "Failed to recount storehouse!");
      setLoading(false);
    }
  };

  const handleDeleteInstance = async (values) => {
    setLoading(true);

    values.creatorId = profile._id;
    var result = await removeStorehouseInstance(values);

    if (result.success) {
      message.success("Product/Raw material type successfully deleted!");
    } else {
      message.error(result.message || "Failed to delete!");
      setLoading(false);
    }
  };

  const showConfirm = (category) => {
    Modal.confirm({
      title: "Are you sure you want to delete this product/raw material type?",
      icon: <ExclamationCircleOutlined />,
      content: "This action cannot be undone.",
      okText: "Yes, delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        handleDeleteInstance(category);
      },
      onCancel() {
        console.log("Cancelled");
      },
    });
  };

  const renderInstanceTable = (categories) => {
    const columns = [
      {
        title: <span className="column-title-font">Name</span>,
        dataIndex: "title",
        key: "title",
        render: (text, record) => (
          <span className="column-content-font">
            {record.title} / {record.sizeOfPack}kg
          </span>
        ),
      },
      {
        title: "Actions",
        key: "action",
        render: (text, record) => (
          <Space>
            <Button
              className="common-table-button"
              type="link"
              size="small"
              icon={<EditOutlined />}
              onClick={() => handleEditInstance(record)}
            />
            <Button
              className="common-table-button"
              type="link"
              size="small"
              icon={<FileExcelOutlined />}
              onClick={() => handleWriteOffInstance(record)}
            />
            <Button
              className="common-table-button"
              type="link"
              size="small"
              icon={<DeleteOutlined />}
              onClick={() => showConfirm(record)}
            />
          </Space>
        ),
      },
    ];

    return (
      <Table
        columns={columns}
        dataSource={categories}
        rowKey="_id"
        loading={loading}
        pagination={false}
      />
    );
  };

  const items = [
    {
      key: "1",
      label: "Products",
      children: renderInstanceTable(productInstances),
    },
    {
      key: "2",
      label: "Raw Materials",
      children: renderInstanceTable(rawMaterialInstances),
    },
  ];

  async function prepareInstances(storehouse) {
    var productInstances = [];
    var rawMaterialInstances = [];
    for (var productCategory of storehouse.productsCategories) {
      if (!productCategory.instances) continue;
      for (var productInstance of productCategory.instances) {
        productInstances.push(productInstance);
      }
    }
    for (var rawMaterialCategory of storehouse.rawMaterialsCategories) {
      if (!rawMaterialCategory.instances) continue;
      for (var rawMaterialInstance of rawMaterialCategory.instances) {
        rawMaterialInstances.push(rawMaterialInstance);
      }
    }
    setProductInstances(productInstances);
    setRawMaterialInstances(rawMaterialInstances);
  }

  useEffect(() => {
    if (!storehouse) {
      setLoading(true);
    } else {
      prepareInstances(storehouse);
      setLoading(false);
    }
  }, [storehouse]);

  return (
    <div className="common-container">
      <Spin spinning={loading}>
        <BackRouteButton />
        <h4 className="common-title--large">All Product/Raw Material Types</h4>
        <Tabs defaultActiveKey="1" items={items}></Tabs>
        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
        >
          <Button type="primary" onClick={handleRecount} block>
            Recount Inventory
          </Button>
        </Space>
      </Spin>
    </div>
  );
};
